import axios from 'axios';
import { API_BASE_URL } from './url_config';

export const addNotification = async (data, token) => {
    let postdata = data;
  return await axios.post(`${API_BASE_URL}/notification/add`, postdata, {
    headers: {
      Authorization: `Bearer ${token}`
    },
  });
};

export const getNotifications = async (token) => {
    return await axios.get(`${API_BASE_URL}/notification/get`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
};

export const deleteNotification = async (id, token) => {
  return await axios.delete(`${API_BASE_URL}/notification/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
}

export const updateNotification= async (id, data, token) => {
  return await axios.put(`${API_BASE_URL}/notification/update/${id}`, data, {
    headers: {
      Authorization: `Bearer ${token}`
    },
  });
};